import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { CmisEntry, GbCmisService } from '../../../../core/gb-api';

@Component({
  selector: 'cap-cmis-modal',
  templateUrl: './cmis-modal.component.html',
  styleUrls: ['./cmis-modal.component.scss'],
  imports: [TranslatePipe]
})
export class CmisModalComponent {
  @Input()
  cmisEntries: Array<CmisEntry>;

  @Input()
  modalTitle: string;

  constructor(
    public activeModal: NgbActiveModal,
    private api: GbCmisService
  ) {}

  decode(uri: string) {
    if (!uri) {
      return '';
    }
    return decodeURI(uri);
  }

  getDokument(entry: CmisEntry) {
    this.api.downloadCmisDocument(entry.cmisId).subscribe((value) => {
      const url = URL.createObjectURL(value);
      window.open(url, '_blank');
    });
  }
}
